export default __webpack_public_path__ + "static/media/ASSETS-06.eebe05a9.png";